import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/styles";
import { createStyles } from "@material-ui/core";
import { MdLogin } from "react-icons/md";
const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      backgroundColor: theme.palette.primary.main,
      color: "#000",
      fontSize: 14,
      height: 48,
      marginBottom: 16,
      width: 250,
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    },
  })
);

const LoginButton = (props) => {
  const classes = useStyles();
  return (
    <Button
      className={classes.button}
      variant="contained"
      onClick={() => props.onClick()}
    >
      <MdLogin style={{ fontSize: "20px", marginRight: "10px" }} />
      {props.label}
    </Button>
  );
};

export default LoginButton;
